var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkEnrollmentFarmerCommitted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/farmer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8511 17.4587C5.85385 19.6909 1.67803 21.756 3.98571 25.506C6.72468 23.7152 9.53289 21.81 12.8178 20.3658C16.501 18.7465 20.7834 17.7068 26.2395 18.0576C29.242 18.2506 32.5999 18.8647 36.4089 20.035C38.0051 16.0445 31.8302 14.8718 27.755 14.4366C22.3655 13.861 15.7422 15.2739 10.8511 17.4587Z",
    fill: "#2C70E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8511 17.4587C15.7422 15.2739 22.3655 13.861 27.755 14.4366C19.505 3.23674 10.8511 11.5444 10.8511 17.4587Z",
    fill: "#2C70E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8126 20.035C12.8126 20.1405 12.8143 20.251 12.8178 20.3658M26.25 17.9167C26.2464 17.9634 26.2429 18.0103 26.2395 18.0576M14.8326 27.8131C9.37512 27.7947 7.92534 27.7899 3.98571 25.506C1.67803 21.756 5.85385 19.6909 10.8511 17.4587M3.98571 25.506C6.72468 23.7152 9.53289 21.81 12.8178 20.3658M25.678 26.7176C30.2768 25.561 35.1396 23.2081 36.4089 20.035C38.0051 16.0445 31.8302 14.8718 27.755 14.4366C22.3655 13.861 15.7422 15.2739 10.8511 17.4587M36.4089 20.035C32.5999 18.8647 29.242 18.2506 26.2395 18.0576M10.8511 17.4587C10.8511 11.5444 19.505 3.23674 27.755 14.4366M12.8178 20.3658C12.8801 22.4466 13.5147 25.975 15.0049 27.8137C17.8369 31.3077 22.3679 33.4145 25.678 26.7176M25.678 26.7176C26.2829 25.044 26.0269 21.0358 26.2395 18.0576M15.0049 27.8137L14.8326 27.8131M15.0049 27.8137C14.9471 27.8135 14.8896 27.8133 14.8326 27.8131M18.4665 26.8329C18.4665 27.3746 18.9056 27.8137 19.4473 27.8137H20.7165C21.2582 27.8137 21.6973 27.3746 21.6973 26.8329M12.8178 20.3658C16.501 18.7465 20.7834 17.7068 26.2395 18.0576",
    stroke: "#2C70E3",
    strokeWidth: 1.38889,
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkEnrollmentFarmerCommitted);
export default __webpack_public_path__ + "static/media/bulk-enrollment-farmer-committed.aa1758a5760d98aac50952fe98458b19.svg";
export { ForwardRef as ReactComponent };